import React from 'react';

import { useLocation } from 'react-router-dom';

import useThemeController from 'hooks/theme/useThemeController';
import AuthLayout from './Auth';
import EmptyLayout from './Empty';
import MainLayout from './Main';

export default function Layout() {
  const authLayoutPaths = [/(signin|password-*)/];
  const emptyLayoutPaths = [/error/];

  const location = useLocation();
  useThemeController();

  if (authLayoutPaths.some((path) => path.test(location.pathname))) {
    return <AuthLayout />;
  }

  if (emptyLayoutPaths.some((path) => path.test(location.pathname))) {
    return <EmptyLayout />;
  }

  return <MainLayout />;
}
